import React from 'react';
import './ImageIcon.css'

function C2wImageIcon( { imgSrc, index = 0} ) {
  return (
    <div className='C2wCountCard_ctn_Img_div' 
        style={{ 
            border: index !== 0 ? '3px solid #141622' : 'none' 
        }}
    >
      <img src={imgSrc} alt='std-image' />
</div>
  )
}

export default C2wImageIcon;
